/*
 * Slim v5.2.1 - Image Cropping Made Easy
 * Copyright (c) 2019 Rik Schennink - https://pqina.nl/slim
 */
<template>
  <div class="slim">
    <slot></slot>
  </div>
</template>

<script>
// Slim (place slim CSS and slim.module.js file in same folder as this file)
import Slim from "./slim.module.js";

export default {
  props: ["options"],
  name: "slim-cropper",
  data() {
    return {
      slim: null
    };
  },
  mounted: function() {
    if (this.options.initialImage) {
      var img = document.createElement("img");
      img.setAttribute("alt", "");
      img.src = this.options.initialImage;
      this.$el.appendChild(img);
    }
    this.slim = new Slim(this.$el, this.options);
  },
  beforeDestroy: function() {
    this.slim.destroy();
  }
};
</script>
<style lang="css">
@import "./slim.min.css";

.slim {
  @apply .rounded-lg;
}

.slim[data-state*="empty"] {
  @apply .border-green-400 .border-2 .border-dashed .bg-green-100;
}

.slim[data-state*="empty"]:hover {
  @apply .bg-green-200;
}
</style>
